import { Const } from '../lib/const.cls'

export const getters = {
    //GET PRICE FEED DATA
    [Const.GET_WEBSOCKET_CONNECTION]: (state) => {
        return state.socketConnected
    },
    //GET PRICE FEED DATA
    [Const.GET_PRICEFEED_DATA]: (state) => {
        return state.PRICEFEED_DATA
    },
    // Get isins list
    [Const.GET_ISINS_LIST]: (state) => {
        return state.IsinsList
    },
    [Const.GET_NOTIFICATION_LIST]: (state) => { return state.notificationList },
    [Const.GET_UNREAD_NOTIFICATION_DATA]: (state) => { return state.notificationUnreadList },

    [Const.GET_SUBSCRIPTION_DETAIL]: (state) => { return state.getSubscriptionDetail },
    [Const.GET_ZULU_ACCOUNT_LIST]: (state) => { return state.zuluAccountList },
    [Const.GET_IB_MAM_PAMM_ACCOUNT_LIST]: (state) => { return state.ibMamPammAccountList },
    //trading-tool
    [Const.GET_SIGNAL_CENTRE]: (state) => { return state.signalCentre },
    [Const.GET_AUTO_CHARTIST]: (state) => { return state.autoChartist },
    [Const.GET_SUB_PLAN_LIST]: (state) => { return state.subPlanList },
    [Const.GET_SUB_PLAN_DETAIL]: (state) => { return state.sunPlanDetail },

    [Const.GET_CURRENT_NEWS]: (state) => { return state.currentNews },
    [Const.GET_CURRENT_NEWS_DETAIL]: (state) => { return state.currentNewsDetails },

    [Const.GET_ECONOMIC_CALENDER_DATA]: (state) => { return state.economicCalData },
    [Const.GET_VPS_LIST]: (state) => { return state.vpsList },
    [Const.GET_VPS_DETAIL]: (state) => { return state.vpsDetail },

    [Const.GET_COUPON_LIST]: (state) => { return state.couponlist },

    [Const.GET_VIDEO_TUTORIAL]: (state) => { return state.VIDEO_TUTORIAL },

    //user
    [Const.GET_USER_PROFILE]: (state) => { return state.userProfile },
    [Const.GET_COUNTRY_TAX_RESIDENCE_NATIONALITY]: (state) => { return state.country_tax_residence_nationality },
    [Const.GET_USER_NOTIFICATIONS]: (state) => { return state.userNotify },
    [Const.GET_EMP_STATUS]: (state) => { return state.empStatus },
    [Const.GET_OCCUPATION]: (state) => { return state.occupation },
    [Const.GET_EDUCATION]: (state) => { return state.education },
    [Const.GET_EST_YEARLY_INCOME]: (state) => { return state.estYearlyIncome },
    [Const.GET_SOURCE_OF_FUNDS]: (state) => { return state.source_of_fund },
    [Const.GET_EST_NET_WORTH]: (state) => { return state.estNetWorth },
    [Const.GET_ANT_ACCOUNT_TURNOVER]: (state) => { return state.antAccountTurnover },
    [Const.GET_COUNTRIES_LIST]: (state) => { return state.countriesList },
    [Const.GET_CITIES_LIST]: (state) => { return state.citiesList },
    [Const.GET_TIN_PASSPORT_OPTION]: (state) => { return state.CRSNUMBER },

    //trading accounts
    [Const.GET_TRADING_ACCOUNT_LIST]: (state) => { return state.tradingAccountList },
    [Const.GET_LIVE_ACCOUNT_LIST]: (state) => { return state.liveAccountList },
    [Const.GET_DEMO_ACCOUNT_LIST]: (state) => { return state.demoAccountList },
    [Const.GET_ACCOUNT_DETAILS]: (state) => { return state.accountDetails },
    [Const.GET_LAST_SELECT_TRADING_ACCOUNT]: (state) => { return state.lastSelectTradingAccount },

    //deposit
    [Const.GET_DEPOSIT_LIST]: (state) => { return state.depositList },
    [Const.GET_DEPOSIT_LIMIT]: (state) => { return state.deposit_limit },

    [Const.GET_EUROPEAN_COUNTRY_LIST]: (state) => { return state.european_countries_list },
    [Const.GET_HELP2PAY_BANK_LIST]: (state) => { return state.getHelp2PayBankList },
    [Const.GET_HELP2PAY_AMOUNT_LIMIT]: (state) => { return state.amountLimit },
    [Const.GET_COUNTRY_CURRENCY]: (state) => { return state.countryCurrency },
    [Const.GET_NUVEI_DETAILS]: (state) => { return state.nuveiData },

    [Const.GET_VERTUPAY_BANK_LIST]: (state) => { return state.getVertupayList },
    [Const.GET_VTP_COUNTRY_CURRENCY]: (state) => { return state.vtpCountryCurrency },
    [Const.GET_VERTUPAY_AMOUNT_LIMIT]: (state) => { return state.vtpAmountLimit },

    //withdrawal
    [Const.GET_WITHDRAWAL_LIST]: (state) => { return state.withdrawalList },
    [Const.GET_WITHDRAWAL_METHOD_RESPONSE]: (state) => { return state.withdrawalMethodResponse },
    [Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP]: (state) => { return state.withdrawalMethodResponseDep },

    //bonus
    [Const.GET_BONUS_LIST]: (state) => { return state.bonusList },

    //support
    [Const.GET_TICKET_DATA]: (state) => { return state.ticketData },
    [Const.GET_TICKET_LIST]: (state) => { return state.ticketList },
    [Const.GET_TICKET_VIEW]: (state) => { return state.ticketView },
    [Const.GET_TICKET_REASON_LIST]: (state) => { return state.ticketReasonList },
    [Const.GET_REASON_LIST]: (state) => { return state.reasonList },

    //bank
    [Const.GET_BANK_LIST]: (state) => { return state.bankList },

    [Const.GET_CHANGE_ACCOUNT_DATA_FORM_FORM_DISPLATY]: (state) => { return state.formDisplayVar },


    //static



    [Const.GET_ENTITY_DATA]: (state) => { return state.entityData },


    [Const.GET_HOOPS_DATA]: (state) => { return state.hoopsData },

    //wallet
    [Const.GET_WALLET_ACCOUNT]: (state) => { return state.walletAccount },
    [Const.GET_WALLET_TRANSACTION]: (state) => { return state.walletTransaction },
    [Const.GET_WALLET_CURRENCY_DATA]: (state) => { return state.walletCurrencyData },
    [Const.GET_ALL_ACCOUNT_LIST]: (state) => { return state.allAccountList },
    [Const.GET_WALLET_BALANCE]: (state) => { return state.walletBalnce },



    //loyality
    [Const.GET_LOYALITY_CARD_DETAIL]: (state) => { return state.loyalityCardDetail },
    [Const.GET_LOYALITY_CARD_TXN]: (state) => { return state.loyalityCardTxn },
    [Const.GET_LOYALITY_LAST_CREDIT]: (state) => { return state.loyalityLastCredit },

    [Const.GET_REFER_LIST]: (state) => { return state.referList },
    [Const.GET_ASTROPAY_METHODS]: (state) => { return state.astroPayCountryMethods },

    //get current country
    [Const.current_country_code]: (state) => { return state.current_country_code },
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/getters.js